import React from "react";
import { useState } from "react";
import GlitchText from "./GlitchText/GlitchText";
import './App.css';
import Squares from "./Square/Squares";
import TiltedCard from "./TiltedCard/TiltedCard";
import LoadingScreen from "./LoadingScreen";
import CustomCursor from "./CustomCursor";

const techStackGroups = [
  {
    title: "Languages",
    items: ["Python", "Java", "C#", "C++", "JavaScript", "HTML5", "CSS3", "SQL"],
  },
  {
    title: "Frontend",
    items: ["React.js", "Tailwind CSS", "Bootstrap", "Responsive Web Design"],
  },
  {
    title: "Backend",
    items: ["Flask", "REST APIs"],
  },
  {
    title: "Databases",
    items: ["MongoDB Atlas", "MySQL"],
  },
  {
    title: "Mobile Development",
    items: ["Flutter"],
  },
  {
    title: "AI & Computer Vision",
    items: ["OpenCV", "face_recognition", "AI Agents", "Prompt Engineering"],
  },
  {
    title: "Cloud & Deployment",
    items: ["Netlify", "Azure App Service", "Render"],
  },
  {
    title: "Version Control & Tools",
    items: ["Git", "GitHub", "Postman", "VS Code", "Android Studio"],
  },
  {
    title: "Core Skills",
    items: [
      "Full-Stack Web Development",
      "REST API Development",
      "Database Design",
      "Authentication",
      "CRUD Applications",
      "Responsive UI Development",
      "Accessibility-Focused Development",
      "Problem Solving",
    ],
  },
];

const certificates = [
  { src: "/CERTI4.jpeg", alt: "Certificate 4" },
  { src: "/CERTI5.png", alt: "Certificate 5" },
  { src: "/Nathan Waghchoure.jpg", alt: "Nathan certificate" },
  { src: "/CERT1.jpg", alt: "Certificate 1" },
  { src: "/CERTI2.jpg", alt: "Certificate 2" },
  { src: "/CERTI3.jpg", alt: "Certificate 3" },
];

const projects = [
  {
    name: "Pathease",
    image: "/pathease.png",
    link: "https://patheasee.netlify.app/",
  },
  {
    name: "Planora",
    image: "/planora.png",
    link: "https://planoraevents.netlify.app/",
  },
  {
    name: "UrbanNest",
    image: "/urbannest.png",
    link: "https://urbannesttt.netlify.app/",
  },
  {
    name: "Sitecrafterz",
    image: "/sitecrafterz.png",
    link: "https://sitecrafterz.netlify.app/",
  },
  {
    name: "Face Recognition",
    image: "/face recognition.png",
    link: "https://faccerecog.netlify.app/",
  },
];

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <LoadingScreen onComplete={() => setIsLoading(false)} />}
      <CustomCursor />
      <Squares
        direction="right"
        speed={0.8}
        squareSize={40}
        borderColor="#ffffff22"
        hoverFillColor="#ffffff11"
      />
      <div id="top" className={`portfolio-page ${isLoading ? "portfolio-page-loading" : "portfolio-page-ready"}`}>
      <nav className="portfolio-navbar" aria-label="Primary navigation">
        <a className="portfolio-brand" href="#top">Nathan Yakob</a>
        <div className="portfolio-nav-links">
          <a href="#about">About</a>
          <a href="#projects">Projects</a>
          <a href="#certificates">Certificates</a>
          <a href="#links">Links</a>
        </div>
      </nav>
 <header className="hero-section">
     <div className="glitch-container">
  <GlitchText text="Hello There!" enableOnHover={false} />


</div>
    </header>
      <main>
        <section id="about" style={{ marginBottom: "40px" }}>
        <div
  style={{
    background: 'rgba(255, 255, 255, 0.1)', // semi-transparent white
    backdropFilter: 'blur(10px)', // glass blur effect
    WebkitBackdropFilter: 'blur(10px)', // for Safari
    borderRadius: '12px',
    padding: '2px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    maxWidth: '1000px',
    margin: '',
    marginTop: '20px',
    textAlign: 'left'
  }}
>
  <h3 style={{ fontFamily: 'Panchang', fontSize: 'larger', color: '#fff' }}>
    About Me
  </h3>
</div>
          <div className="about-content">
            <div className="about-card-wrap">
              <TiltedCard
                imageSrc="/port2.jpeg"
                altText="Nathan Waghchoure"
                captionText="Nathan Waghchoure"
                containerHeight="340px"
                containerWidth="100%"
                imageHeight="320px"
                imageWidth="260px"
                rotateAmplitude={10}
                scaleOnHover={1.05}
                showMobileWarning={false}
                showTooltip={true}
                displayOverlayContent={true}
                overlayContent={
                  <div className="about-card-overlay">
                    <span>Nathan Waghchoure</span>
                    <small>Full-stack Developer</small>
                  </div>
                }
              />
            </div>
            <div className="about-copy">
              
              <p className="about-text">Hi, I'm Nathan Waghchoure, an Information Technology graduate passionate about building innovative and user-friendly software solutions. I specialize in full-stack web development using Python, React, Flask, JavaScript, MongoDB, and MySQL. I enjoy solving real-world problems through technology and continuously learning new skills in AI, cloud computing, and modern web development. I'm always excited to collaborate, grow, and create impactful digital experiences.
</p>
            </div>
          </div>

        </section>

        <section id="projects" style={{ marginBottom: "40px" }}>
              <div
  style={{
    background: 'rgba(255, 255, 255, 0.1)', // semi-transparent white
    backdropFilter: 'blur(10px)', // glass blur effect
    WebkitBackdropFilter: 'blur(10px)', // for Safari
    borderRadius: '12px',
    padding: '2px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    maxWidth: '1000px',
    margin: '',
    marginTop: '20px',
    textAlign: 'left'
  }}
>
  <h3 style={{ fontFamily: 'Panchang', fontSize: 'larger', color: '#fff' }}>
    PROJECTS
  </h3>
</div>
          <div className="project-grid">
            {projects.map((project) => (
              <a
                key={project.name}
                className="project-card"
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open ${project.name}`}
              >
                <img src={project.image} alt={`${project.name} preview`} />
                <span>{project.name}</span>
              </a>
            ))}
          </div>
          
        </section>

        <section id="certificates" className="certificates-section">
  <div
  style={{
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '12px',
    padding: '2px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    maxWidth: '1000px',
    marginTop: '20px',
    textAlign: 'left'
  }}
>
  <h3 style={{ fontFamily: 'Panchang', fontSize: 'larger', color: '#fff' }}>
    CERTIFICATES
  </h3>
</div>

<div
  style={{
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    padding: '10px',
    marginTop: '10px',
    scrollbarWidth: 'none', // Firefox
    msOverflowStyle: 'none', // IE and Edge
  }}
  className="scroll-container"
>
  {certificates.map((certificate) => (
    <img
      key={certificate.src}
      src={certificate.src}
      alt={certificate.alt}
      className="certificate-image"
    />
  ))}
</div>

<style>
  {`
    .scroll-container::-webkit-scrollbar {
      display: none;
    }
  `}
</style>

        </section>
        <footer id="links">
          <div
  style={{
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '12px',
    padding: '2px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    width: '100%',
    marginTop: '20px',
    textAlign: 'left'
  }}
>
  <h3 style={{ fontFamily: 'Panchang', fontSize: 'larger', color: '#fff', textAlign:"center" }}>
  LINKS
  </h3>


<div style={{ marginTop: '10px', display: 'flex', gap: '20px' }}>
  <a
    href="https://www.linkedin.com/in/nathan-waghchoure-7b2225353/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: '#0e76a8', fontSize: '30px' }}
  >
    <i className="fab fa-linkedin"></i>
  </a>
  <a
    href="https://www.instagram.com/justttnathan_/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: '#e1306c', fontSize: '30px' }}
  >
    <i className="fab fa-instagram"></i>
  </a>
 
  <a
  href="https://github.com/nathanyakob19"
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: '#fff', fontSize: '30px' }}
>
  <i className="fab fa-github"></i>
</a>
</div>
<div
      style={{
      
      }}
    >
      <h3 style={{ fontFamily: 'Panchang', fontSize: 'larger', color: '#fff' , textAlign:"center"}}>
        My Tech Stack
      </h3>
      <div className="tech-stack-groups">
        {techStackGroups.map((group) => (
          <section className="tech-stack-group" key={group.title}>
            <h4>{group.title}</h4>
            <div className="tech-stack-items">
              {group.items.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>

</div>

        </footer>
      </main>
      </div>
    </>
  );
}

export default App;
